<template>
  <b-modal
    ref='productLinkedModal'
    id='productLinkedModal'
    header-bg-variant='info'
    header-text-variant='light'
    size='xl'
    title="O produto esta vinculado à hierarquia"
    @show='showModal()'
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
  >
    <b-overlay
      :show='loadingHierarchical'
      rounded
      no-center
      opacity='0.8'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
    >
      <section class='modal-font-family' v-if="productsHierarchy && productsHierarchy.length > 0">
        <p v-if="productLegalConsultation && productLegalConsultation.name">
          <strong class='text-danger'>Atenção: </strong>
          O cargo <strong>{{ productLegalConsultation.name }}</strong> está vinculado aos setores abaixo.
        </p>
        <p>
          Selecione os setores que terão as informações atualizadas.
        </p>
        <section class="sectors">
          <section
            class="mb-3"
            v-for="(sector, i) in productsHierarchy"
            :key="`${sector._id}_${i}`"
          >
            <span class="sector-name">Setor: {{sector.sector.name}}</span>
            <section
              class="mt-1"
              v-for="(role, indexSectorRole) in sector.roles"
              :key="`${role._id}_${indexSectorRole}`"
            >
              <section class="d-flex align-items-center">
                <b-icon
                  class="mr-2"
                  icon="chevron-down"
                >
                </b-icon>
                <p class="mb-1 role-name">Cargo: {{ role.name }}</p>
              </section>
              <section class="d-flex">
                <section class="ml-2 line">

                </section>
                <section
                  class="ml-3"
                  v-for="(product, indexRoleProductLegalConsultation) in role.products"
                  :key="`${product._id}_${indexRoleProductLegalConsultation}`"
                >
                  <b-form-checkbox
                    v-if="product && product._id"
                    :id="product._id"
                    :name="product._id"
                    :value="product._id"
                    v-model="selectedProductHierarchyIds"
                  >
                    <span
                      class="mb-1 product-name"
                    >
                      Produto: {{ product.name }}
                    </span>
                  </b-form-checkbox>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>

      <template v-slot:overlay>
        <section class='text-center modal-font-family'>
          <b-spinner
            style='width: 2.5rem; height: 2.5rem'
            variant='primary'
            label='Large Spinner'
          ></b-spinner>
          <h5 class='text-primary text'>
            Buscando a hierarquia vinculada ao produto...
          </h5>
        </section>
      </template>
    </b-overlay>

    <template #modal-footer>
      <section class='w-100 d-flex modal-font-family'>
        <b-button
          class="w-50 mr-1"
          variant="danger"
          @click='closeModal()'
        >
          <span>Cancelar</span>
        </b-button>

        <b-button
          class="w-50 ml-1"
          variant="success"
          :disabled="disabled"
          @click='setSelected()'
        >
          <span>OK</span>
        </b-button>
      </section>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductLinkedModal',
  components: {},
  props: {
    productLegalConsultation: {
      type: Object,
      required: false,
      default: Object
    },
    productsHierarchy: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      loadingHierarchical: false,
      selectedProductHierarchyIds: []
    }
  },
  computed: {
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
    disabled() {
      return !(this.selectedProductHierarchyIds && this.selectedProductHierarchyIds.length > 0)
    }
  },
  methods: {
    ...mapActions('productLegalConsultation', {
      handleGetProductLegalConsultationHierarchical: 'handleGetProductLegalConsultationHierarchical'
    }),
    ...mapActions('sectorRole', {
      handleGetByRole: 'handleGetByRole'
    }),

    async showModal() {
      try {
        this.selectedProductHierarchyIds = []
      } catch (e) {
      }
    },

    setSelected() {
      this.$emit('setSelected', {
        productHierarchyIds: this.selectedProductHierarchyIds,
      })
    },

    closeModal() {
      this.$bvModal.hide('productLinkedModal')
    },
  },
  created() {
  }
}
</script>

<style lang='scss' scoped>
.alert-container {
  background: #FFF3E0;
  border-left: 4px solid #FF9800;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
}

.alert-title {
  color: #E65100;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.alert-message {
  color: #262626;
  font-size: 15px;
  line-height: 1.6;
  margin: 10px 0;

  strong {
    font-weight: 700;
    color: #022245;
  }
}

.sectors {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(33%, auto));

  .title {
    font-weight: 700;
    font-size: 18px;
    color: #262626;
  }

  .sector-name {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
  }

  .role-name {
    font-weight: 500;
    font-size: 15px;
    color: #000000;
  }

  .line {
    border-left: 1px solid #9C9C9C;
  }

  .product-name {
    font-weight: 400;
    font-size: 15px;
    color: #000000;
  }
}
</style>
